export default __webpack_public_path__ + "static/media/icon.diapers.40acdd4b.svg";